import Image from "gatsby-image";
import React from "react";
import {FarmaBialkaImage} from "src/shared/Hooks/CasesNew/FarmaBialka/FarmaBialkaImage";
import Opengraph from "../../../../assets/images/cases/farma-bialka/og.png"

export const FarmaBialka = () => {
  const images = FarmaBialkaImage();
  return {
    color:          "#281B22",
    title:          "Farma Białka",
    seo:
                    "Zdrowy i naturalny marketing.",
    slug:           "farma-bialka",
    opengraph:      Opengraph,
    hero:           {
      title:      "Zdrowy i naturalny marketing.",
      color:      "#281B22",
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"cover"}
                      fluid={images.hero.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.detail.childImageSharp.fluid}
                    />
                  ),
    },
    what_we_did:    {
      title:        "Starannie zaplanowana strategia marketingowa",
      technologies: [
        "Identyfikacja wizualna",
        "Social media",
        "Kampania reklamowa",
        "Zdjęcia produktowe",
      ],
      text:
                    "Farma Białka - firma, dla której mieliśmy przyjemność wykonać kompleksowe działania marketingowe. Jaki cel nam przyświecał? Przedstawienie całemu światu płynnego białka jaj! Jak tego dokonaliśmy? Zaczęliśmy od przeprowadzenia audytu, który wskazał, na czym przede wszystkim powinniśmy się skupić. Wprowadziliśmy nową identyfikację wizualną, a następnie skupiliśmy się na marketingu online - prowadziliśmy profile social media, organizowaliśmy akcje reklamowe, wykonaliśmy strony typu landing page. Jak nam to wyszło? Zobaczcie sami!",
      list:         [
        "Opracowaliśmy nową identyfikację wizualną",
        "Wykonaliśmy zdjęcia produktowe",
        "Przeprowadziliśmy kampanie marketingowe",
        "Zaprojektowaliśmy strony typu landing page",
        "Obsługiwaliśmy profile w mediach społecznościowych",
      ],
    },
    logo:           {},
    list:           {
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_bg.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_detail.childImageSharp.fluid}
                    />
                  ),
    },
    full_images:    {
      first:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_1.childImageSharp.fluid}
                 />
               ),
      },
      second: {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_2.childImageSharp.fluid}
                 />
               ),
      },
      third:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_3.childImageSharp.fluid}
                 />
               ),
      },
      fourth: {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_4.childImageSharp.fluid}
                 />
               ),
      },
      fifth:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_5.childImageSharp.fluid}
                 />
               ),
      },
    },
    headers:        {
      first:  "Szczegółowa księga znaku",
      second: "Dedykowany landing page",
    },
    text_boxes:     {
      first:   {
        title: "Nowoczesne logo dla nowoczesnego produktu",
        text:  "Logo składa się z sygnetu i logotypu. Powstało z połączenia jajka i płynnego białka, przedstawionego za pomocą cienkich linii. Jest proste i nowoczesne, budzi bardziej pozytywne i “naturalne” skojarzenia wśród odbiorców. Odzwierciedla charakterystyczne cechy oferowanego produktu. Dla osób, które nie znają Farmy Białka, jest czytelne i lepiej przedstawia branżę, w której działa marka.",
      },
      second:  {
        title: "Odświeżony wizerunek płynnego białka jaj",
        text:
               "Kolejnym krokiem był projekt nowych etykiet na butelki. Są spójne z nowo opracowanym logo i całym brandingiem marki. Etykiety zawierają wszystkie informacje o produkcie, które wyeksponowaliśmy w czytelny i przejrzysty sposób. Następnie utrwaliliśmy ich wizerunek na sesji produktowej, która posłużyła nam również w dalszej części współpracy.  ",
      },
      third:   {
        title: "Przewodnik po nowym brandingu",
        text:
               "Księga znaku to gwarancja skutecznego i prawidłowego używania elementów identyfikacji wizualnej. Dlatego wszystko, co zaprojektowaliśmy, zebraliśmy w jednym dokumencie. Uwzględniliśmy w nim najważniejsze zasady tworzenia różnego rodzaju materiałów z użyciem nowego logo. ",
      },
      fourth:  {
        title: "Kreatywna komunikacja online",
        text:
               "Podczas naszej współpracy przeprowadziliśmy szereg akcji marketingowych, które pozwoliły nam dotrzeć do wielu grup odbiorców. Największym zainteresowaniem cieszyła się promocja pozwalająca przetestować płynne białko jaj, na potrzeby której stworzylismy landing page oraz prowadziliśmy reklamy w social mediach. Ponadto wysyłaliśmy newsletter, zaprojektowaliśmy e-booki z przepisami i zorganizowaliśmy kilka konkursów.",
      },
      fifth:   {
        title: "Skuteczne działania w social mediach i Google",
        text:
               "Ponieważ Farma Białka posiadała już profile w mediach społecznościowych, ich kontynuacja była dla nas oczywista. Prowadziliśmy komunikację za pomocą Facebooka i Instagrama. By była jak najbardziej skuteczna, nawiązaliśmy wiele współprac z influencerami. Dodatkowo promowaliśmy markę za pomocą Google Ads oraz Facebook Ads, dzięki czemu udało nam się dotrzeć do wielu nowych grup odbiorców. ",
      },
      sixth:   {
        title: "Zakupy w każdym miejscu i o każdej porze",
        text:
               "Według najnowszych danych coraz więcej Polaków robi zakupy przy użyciu swojego smartfona. Z tego powodu oczywistością było dostosowanie projektu do urządzeń mobilnych. Funkcjonalności, które zastosowaliśmy, pozwalają na szybkie zakupy za pomocą kilku kliknięć! ",
      },
      seventh: {
        title: "Skuteczne działania sprzedażowe",
        text:
               "W naszym projekcie uwzględniliśmy również rozwiązania, które będę wspierać pozycjonowanie się sklepu w wyszukiwarce. Dzięki połączeniu witryny z blogiem możliwe jest zdobywanie nowych klientów. A dzięki wykorzystanemu systemowi CMS istnieje również możliwość uzupełnienia strony o nowe wpisy w prosty i intuicyjny sposób.",
      },
    },
    content_images: {
      first:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_1.childImageSharp.fluid}
                />
              ),
      second: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_2.childImageSharp.fluid}
                />
              ),
      third:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_3.childImageSharp.fluid}
                />
              ),
      fourth: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_4.childImageSharp.fluid}
                />
              ),
      fifth:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_5.childImageSharp.fluid}
                />
              ),
    },
  };
};
